<header
  fxLayout="row"
  fxLayoutAlign="center center"
  class="short-header"
>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    class="header-content-container"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      class="header-title-container"
    >
      <h2 class="header-title">
        Parteneri
      </h2>
      <p class="title-details">
        Pentru confortul și bunăstarea ta și a familiei tale avem parteneri de calitate și încredere.
      </p>
    </div>
  </div>
</header>

<section
  fxLayout="row wrap"
  fxLayoutAlign="center center"
  fxLayoutAlign.gt-xs="center center"
  class="partners-list"
>
  <a
    fxLayout="column"
    fxLayoutAlign="center center"
    class="partner-item"
    *ngFor="let partner of partners"
    [href]="[partner.link]"
    target="_blank"
  >
    <div class="wrapper-effect"></div>
    <div
      class="partner-image"
      [ngStyle]="{'background-image': 'url(' + partner.image.url +')'}"
    >
    </div>
  </a>
</section>



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.html